import { H2, L, Note, P, Ul } from '@/features/guide/prose'

export function BranchOperationVi() {
  return (
    <>
      <P>
        Truy cập romi.io.vn/url-nha-hang (thay “url-nha-hang” bằng Tên URL thực tế) và đăng nhập, hoặc đăng nhập rồi đi tới nhà hàng qua{' '}
        <L k="nav.myRestaurants" />. Ấn vào chi nhánh để tới trang chi nhánh. Nhân viên ấn <L k="landing.openQueue" />; <L k="role.admin" /> trở lên ấn{' '}
        <L k="landing.manageBranch" /> rồi chọn <L k="nav.queue" /> trong menu.
      </P>
      <P>
        Có 4 trang vận hành chi nhánh: <L k="nav.queue" />, <L k="nav.sessions" />, <L k="nav.createOrder" /> (nhân viên tạo đơn cho khách) và{' '}
        <L k="nav.search" /> (đơn hàng và phiên bàn).
      </P>
      <H2>Hàng đợi</H2>
      <Ul>
        <li>
          Mặc định hiển thị 4 trạng thái đang xử lý: <L k="track.status.sent" />, <L k="track.status.confirmed" />, <L k="track.status.processing" /> và{' '}
          <L k="track.status.ready" />. Ấn vào một trạng thái ở đầu trang để ẩn/hiện; lựa chọn được ghi nhớ trên thiết bị đó (ví dụ: màn hình trong bếp
          chỉ hiện Đã nhận và Đang làm, màn hình nhân viên bên ngoài hiện Đã gửi và Sẵn sàng). Luôn còn ít nhất một trạng thái được hiển thị.
        </li>
        <li>
          Mỗi đơn có nút chuyển sang trạng thái kế tiếp: <L k="queue.next.sent" />, <L k="queue.next.confirmed" />, <L k="queue.next.processing" />,{' '}
          <L k="queue.next.ready" />.
        </li>
        <li>Đầu trang hiển thị cửa hàng đang mở hay đóng và mã PIN đặt món hiện tại.</li>
      </Ul>
      <H2>Phiên bàn</H2>
      <P>Các phiên đang mở (bàn đang có khách) hiển thị tại đây. Ấn vào từng bàn để mở trang chi tiết phiên.</P>
      <P>
        Tại trang chi tiết có thể in hóa đơn (<L k="orderDetails.print" />), chuyển phiên sang bàn khác (<L k="sessions.changeTable" />; nếu bàn đó đang có
        khách thì gộp hai nhóm vào một hóa đơn), và đóng phiên (<L k="sessions.close" />) sau khi khách thanh toán để bàn sẵn sàng cho đợt khách mới. Phiên
        không đóng được khi còn đơn đang xử lý; hãy hoàn tất hoặc hủy các đơn đó trước.
      </P>
      <Note>
        Luôn đóng phiên sau khi khách thanh toán. Nếu không, các đơn cũ vẫn thuộc phiên và đợt khách mới đặt món tại bàn đó sẽ thấy cả đơn cũ lẫn đơn mới.
      </Note>
      <H2>Tạo đơn</H2>
      <P>
        Nhân viên tạo đơn cho khách tại đây. Chọn <L k="createOrder.dineIn" /> kèm bàn hoặc <L k="order.takeAway" />, và có thể{' '}
        <L k="createOrder.forCustomer" /> để đơn hiện trong lịch sử của khách. Đơn do nhân viên tạo bắt đầu ở trạng thái <L k="track.status.confirmed" />.
      </P>
      <H2>Tìm kiếm</H2>
      <P>Giúp nhân viên tìm một đơn hoặc phiên cụ thể, theo mã, theo số đơn và ngày, hoặc theo bàn.</P>
    </>
  )
}
